import { render } from "./FolhaModal.vue?vue&type=template&id=607710a6&scoped=true"
import script from "./FolhaModal.vue?vue&type=script&lang=js"
export * from "./FolhaModal.vue?vue&type=script&lang=js"

import "./FolhaModal.vue?vue&type=style&index=0&id=607710a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607710a6"]])

export default __exports__